<div class="modal-container">
  <div class="modal-header no-print">
    <h2 mat-dialog-title>
      <mat-icon>print</mat-icon>
      <span>Imprimir Extrato de Movimentações</span>
    </h2>
    <button mat-icon-button (click)="fechar()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="content-body modal-print-container">
    @if (isLoading) {
    <div class="loading-container no-print">
      <app-loading-box width="100%" height="320px"></app-loading-box>
    </div>
    }

    <div [hidden]="isLoading">
      <div class="relatorio-header">
        <h3>Extrato de Movimentações</h3>
        <span>{{ quantidadeLancamentos }} lançamento(s)</span>
      </div>

      @if (data.resumoFiltros?.length) {
      <div class="filtros-aplicados">
        @for (filtro of data.resumoFiltros; track filtro) {
        <span class="filtro-item">{{ filtro }}</span>
        }
      </div>
      }

      @if (relatorioLancamentos.length > 0) {
      <div>
        <div class="table-responsive">
          <table mat-table [dataSource]="relatorioLancamentos">
            <ng-container matColumnDef="dataMovimentacao">
              <th mat-header-cell *matHeaderCellDef>Data</th>
              <td mat-cell *matCellDef="let element">
                {{ element.dataMovimentacao | date: 'dd/MM/yyyy' }}
              </td>
            </ng-container>
            <ng-container matColumnDef="descricaoContaFinanceira">
              <th mat-header-cell *matHeaderCellDef>Conta</th>
              <td mat-cell *matCellDef="let element">{{ element.descricaoContaFinanceira }}</td>
            </ng-container>
            <ng-container matColumnDef="descricao">
              <th mat-header-cell *matHeaderCellDef>Histórico</th>
              <td mat-cell *matCellDef="let element">{{ element.descricao }}</td>
            </ng-container>
            <ng-container matColumnDef="cliente">
              <th mat-header-cell *matHeaderCellDef>Cliente</th>
              <td mat-cell *matCellDef="let element">{{ element.cliente || '-' }}</td>
            </ng-container>
            <ng-container matColumnDef="descricaoCategoria">
              <th mat-header-cell *matHeaderCellDef>Categoria</th>
              <td mat-cell *matCellDef="let element">{{ element.descricaoCategoria || '-' }}</td>
            </ng-container>
            <ng-container matColumnDef="valor">
              <th mat-header-cell *matHeaderCellDef>Valor</th>
              <td mat-cell *matCellDef="let element" [class.valor-entrada]="element.isEntrada"
                [class.valor-saida]="!element.isEntrada">
                {{ formatarValor(element.valor, element.isEntrada) }}
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
        <!-- Summary cards -->
        <div class="resumo-grid">
          <div class="resumo-item">
            <span class="resumo-label">Saldo Inicial</span>
            <strong>{{ saldoInicial | currency: 'BRL' : 'symbol' : '1.2-2' : 'pt-BR' }}</strong>
          </div>
          <div class="resumo-item">
            <span class="resumo-label">Entradas</span>
            <strong class="valor-entrada">{{
              totalEntradas | currency: 'BRL' : 'symbol' : '1.2-2' : 'pt-BR'
              }}</strong>
          </div>
          <div class="resumo-item">
            <span class="resumo-label">Saídas</span>
            <strong class="valor-saida">{{
              totalSaidas | currency: 'BRL' : 'symbol' : '1.2-2' : 'pt-BR'
              }}</strong>
          </div>
          <div class="resumo-item">
            <span class="resumo-label">Saldo Final</span>
            <strong [class.valor-entrada]="saldoFinal > 0" [class.valor-saida]="saldoFinal < 0">
              {{ saldoFinal | currency: 'BRL' : 'symbol' : '1.2-2' : 'pt-BR' }}
            </strong>
          </div>
        </div>
        <!-- Current account balances -->
        @if (saldosContasAtuais.length > 0) {
        <div class="contas-section">
          <h4>Saldo Atual das Contas</h4>
          <div class="contas-grid">
            @for (conta of saldosContasAtuais; track conta) {
            <div class="conta-item">
              <span>{{ conta.descricaoContaFinanceira }}</span>
              <strong [class.valor-entrada]="conta.saldoAtual > 0" [class.valor-saida]="conta.saldoAtual < 0">
                {{ conta.saldoAtual | currency: 'BRL' : 'symbol' : '1.2-2' : 'pt-BR' }}
              </strong>
            </div>
            }
          </div>
        </div>
        }
        @if (exibirObservacaoSaldo) {
        <div class="observacao-saldo">
          * O saldo anterior + entradas − saídas não corresponde ao saldo atual das contas, pois pode
          existir um ajuste de saldo no período.
        </div>
        }
      </div>
      } @else {
      <div class="empty-state">
        <p>Nenhum registro encontrado para os filtros selecionados.</p>
      </div>
      }
    </div>
  </div>

  <div class="modal-footer no-print">
    <button mat-stroked-button class="btn-secondary" (click)="fechar()">Cancelar</button>
    @if (!isLoading && relatorioLancamentos.length > 0) {
    <button mat-flat-button class="btn-primary" (click)="imprimir()">
      <mat-icon>print</mat-icon>
      Imprimir
    </button>
    }
  </div>
</div>